export default {
  methods: {
    gradientSwitcher: roleType => 'gradient-' + roleType
  }
}



// WEBPACK FOOTER //
// ./src/mixins/GradientSwitcher.js